import { gql } from '../__generated__';

export const IdentityProviderSummaryItem = gql(`
  fragment IdentityProviderSummaryItem on IdentityProviderSummary {
    bksID
    adfsId
    scheme
    companyName
    emailDomains
    isRestricted
    extraUserPercentage
    seatsBought
    seatsInUse
    seatLimit
    hasRoomForNewUser
    subscriptions {
      subscriptionId
      name
      bought
      inUse
    }
    scimEnabled
    scimAuthoritative
    scimHasActiveToken
    scimActiveUsers
    scimInactiveUsers
    scimLastContactAt
    scimTenantUrl
    identityBaseUrl
    clientSecretValid
    clientSecretMessage
    clientSecretCheckedAt
  }
`);

export const GET_IDENTITY_PROVIDER_SUMMARY = gql(`
  query GetIdentityProviderSummary($bksID: Int!) {
    summary: getIdentityProviderSummary(bksID: $bksID) {
      ...IdentityProviderSummaryItem
    }
  }
`);

export const ALL_IDENTITY_PROVIDERS = gql(`
  query AllIdentityProviders {
    providers: allIdentityProviders {
      ...IdentityProviderSummaryItem
    }
  }
`);

export const GET_IDENTITY_BASE_URL = gql(`
  query GetIdentityBaseUrl {
    identityBaseUrl: getIdentityBaseUrl
  }
`);

export const UPDATE_SEAT_LIMIT = gql(`
  mutation UpdateSeatLimit($input: UpdateSeatLimitInput!) {
    updateSeatLimit(input: $input) {
      ...IdentityProviderSummaryItem
    }
  }
`);

export const TEST_CLIENT_SECRET = gql(`
  mutation TestClientSecret($input: TestClientSecretInput!) {
    testClientSecret(input: $input) {
      id
      valid
      errorCode
      message
      checkedAt
    }
  }
`);

export const PortalLoginItem = gql(`
  fragment PortalLoginItem on PortalLoginModel {
    bksID
    scheme
    groupId
    otherRules {
      clientAuthorizationID
      requiredClaims {
        type
        value
      }
    }
  }
`);

export const GET_PORTAL_LOGIN = gql(`
  query GetPortalLogin($bksID: Int!) {
    portalLogin: getPortalLogin(bksID: $bksID) {
      ...PortalLoginItem
    }
  }
`);

export const SET_PORTAL_LOGIN_GROUP = gql(`
  mutation SetPortalLoginGroup($input: SetPortalLoginGroupInput!) {
    portalLogin: setPortalLoginGroup(input: $input) {
      ...PortalLoginItem
    }
  }
`);
